export const CALL_API = 'CALL_API';

